import React from 'react';
import cn from 'classnames';

import styles from './top-label.module.scss';

interface ITopLabelProps {
  label: string;
  required?: boolean;
  id?: string;
  withMargin?: boolean;
}

export default function TopLabel({
  required = false,
  label,
  id,
  withMargin = true,
}: ITopLabelProps) {
  return (
    <label
      htmlFor={id}
      className={cn(styles['top-label'], {
        [styles['with-margin']]: withMargin,
      })}
    >
      {`${label} `}
      {required && (<span>*</span>)}
    </label>
  );
}
